import React, { useState, useEffect } from 'react'
import Layout from '../Layout'
import JewellerySectionone from './JewellerySectionone'
import JewelleryIntro from './JewelleryIntro'
import JewellerySectionthree from './JewellerySectionthree'
import JewelleryAllSession from './JewelleryAllSession'
import JewelleryBlogPost from './JewelleryBlogPost'
import JVSectionfive from './JVSectionfive'
import JewelleryNewsletter from './JewelleryNewsletter'
import JewellerySlider from './JewelleryAllSession/jewllerySlider'
import SuccessStorySlider from '../StartUp/SuccessStorySlider'
import AllSectionone from '../ReusableComp/Sectionone';
import * as Images from '../../assets';
import JewelleryCrafting from './JewelleryCrafting'
import HISlider from '../HeadwayInitiatives/HISlider'
import { fetchWithFormData } from '../../apiGeneralFunction'
import { trackCustomEvent } from '../../event_firebase';

const JewelleryVidhyapithPage = () => {

    const [data, setData] = useState([]);

  useEffect(() => {

    const formData = new FormData();

    fetchWithFormData(`jewellery_vidyapith`, formData)
      // .then(data => setData(data[0].data))
      .then(data => {
        if (data?.status === true) {
          setData(data?.data);
            trackCustomEvent('jewellery_vidyapith', { status: true });
        }
        else {
          // console.error('Status is not true:', data?.status);
          setData("null");
          trackCustomEvent('jewellery_vidyapith', { status: false });
        }
      })
      .catch(
      // error => console.error('Error fetching data:', error)
    );

  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  return (
    <Layout>
      {/* <JewellerySectionone /> */}
      <AllSectionone
        src={Images.jv_bg_new}
        title={'Jewellery Vidhyapith'}
        link_to2={'/our_services'}
        link_name2={'Our Services'}
        link_to3={'/jewellery_vidhyapith'}
        link_name3={'Jewellery Vidhyapith'}
      />
      <JewelleryIntro />
      <JewellerySectionthree />
      {/* <HISlider/> */}
      <JewelleryAllSession data={data?.galleries} />
      <JVSectionfive youtubeData={data?.youtube_link} />
      <JewelleryCrafting/>
      {/* <JewelleryBlogPost /> */}
      <JewelleryNewsletter />

      {/* <JewellerySlider /> */}
    </Layout>
  )
}

export default JewelleryVidhyapithPage